import React from 'react';
import { Button, ModalConfirmation } from '@bynder/design-system';
import { Translate, useTranslate } from '@bynder/localization';
import { Group } from './types';
import { API } from './helpers';

interface Props {
	group?: Group;
	isOpen: boolean;
	onConfirm: (confirmed?: boolean) => void;
}

export function GroupRemoveConfirmation({ group, isOpen, onConfirm }: Props) {
	const { translate } = useTranslate();

	async function confirmRemove() {
		if (group) {
			const formData = new FormData();
			formData.append('ID', group.id);

			try {
				await API.removeGroup(formData);
				onConfirm(true);
			} catch (err) {
				throw new Error(`error calling endpoint: ${err}`);
			}
		}
	}

	if (!group) {
		return null;
	}

	return (
		<ModalConfirmation
			title={translate('confirm.RemoveGroup')}
			actionPrimary={
				<Button
					aria-label="remove-group"
					variant="primary"
					onClick={confirmRemove}
					data-testid="wf-group-management-group-remove-confirm"
				>
					<Translate id="workflow.YesRemove" />
				</Button>
			}
			actionSecondary={
				<Button
					aria-label="remove-group"
					variant="secondary"
					onClick={() => onConfirm(false)}
					data-testid="wf-group-management-group-remove-cancel"
				>
					<Translate id="workflow.No" />
				</Button>
			}
			isOpen={isOpen}
			onClose={() => onConfirm(false)}
		>
			{translate('workflow.DeleteConfirmation', { '1': group.name })}
		</ModalConfirmation>
	);
}
